import { render, staticRenderFns } from "./DiscountLogicSettings.vue?vue&type=template&id=11bfc0ca"
import script from "./DiscountLogicSettings.vue?vue&type=script&lang=js"
export * from "./DiscountLogicSettings.vue?vue&type=script&lang=js"
import style0 from "./DiscountLogicSettings.vue?vue&type=style&index=0&id=11bfc0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports